import { render, staticRenderFns } from "./solutions-menu.vue?vue&type=template&id=f1b66f2a&scoped=true"
import script from "./solutions-menu.vue?vue&type=script&lang=js"
export * from "./solutions-menu.vue?vue&type=script&lang=js"
import style0 from "./solutions-menu.vue?vue&type=style&index=0&id=f1b66f2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b66f2a",
  null
  
)

export default component.exports